export const EstadoDocumentoGenerico = Object.freeze({
    PENDIENTE_FIRMA: "PENDIENTE_FIRMA",
    FIRMADO: "FIRMADO",
    RECHAZADO: "RECHAZADO"
});
